import React, { useEffect } from 'react'
import './resume.css'
import ResumeApi from "./ResumeApi"
import CardEducation from './CardEducation'
import CardExperience from './CardExperience'
import Aos from 'aos';
import 'aos/dist/aos.css';

const Resume = () => {

  //Animation
  useEffect(() => {
    Aos.init({
        duration: 2000,
        once: false,
    });
  },[]);

  return (
    <>
        <section id='resume' className='resume container'>
            <div className='resume__container'>
                <div data-aos="zoom-in" className='container__heading'>
                    <h4>2+ YEARS OF EXPERIENCE</h4>
                    <h1>My Resume</h1>
                </div>

                <div className='content-section'>
                    <div className='left'>
                        <div data-aos="fade-up" className='container__heading'>
                            <h4>2015-2023</h4>
                            <h2>Education Quality</h2>
                        </div>

                        <div className='content'>
                            {ResumeApi.map((val, id) => {
                            if (val.category === "education") {
                                return <CardEducation 
                                    key={id} 
                                    title={val.title} 
                                    year={val.year} 
                                    rate={val.rate} 
                                    desc1={val.desc1}
                                    desc2={val.desc2}
                                    desc3={val.desc3}
                                    desc4={val.desc4}
                                    desc5={val.desc5}
                                />
                            }
                            })}
                        </div>
                    </div>
                    <div className='left'>
                        <div data-aos="fade-up" className='container__heading'>
                            <h4>2019-2023</h4>
                            <h2>Job Experience</h2>
                        </div>

                        <div className='content'>
                            {ResumeApi.map((val, index) => {
                            if (val.category === "experience") {
                                return <CardExperience 
                                    key={index} 
                                    title={val.title} 
                                    year={val.year} 
                                    rate={val.rate} 
                                    desc1={val.desc1}
                                    desc2={val.desc2}
                                    desc3={val.desc3}
                                    desc4={val.desc4}
                                    desc5={val.desc5}
                                />
                            }
                            })}
                        </div>
                    </div>
                </div>
            </div>
      </section>
    </>
  )
}

export default Resume